{
  "helloWorld": "Hej, Verden!",
  "clickMe": "Klik her",
  "healthCheckFailed": "Sundhedstjek mislykkedes",
  "errors": {
    "unexpected": "Der opstod en uventet fejl"
  },
  "error": {
    "title": "Noget gik galt",
    "description": "Der opstod en uventet fejl. Du kan prøve igen eller gå til forsiden.",
    "tryAgain": "Prøv igen",
    "goHome": "Gå til forsiden"
  },
  "dev": {
    "errorPreview": "Fejlvisning"
  },
  "actions": {
    "label": "Handlinger",
    "edit": "Rediger",
    "delete": "Slet",
    "save": "Gem",
    "cancel": "Annuller",
    "expand": "Udvid",
    "collapse": "Fold sammen"
  },
  "validation": {
    "tooLong": "Skal være {{max}} tegn eller færre",
    "tooShort": "Påkrævet",
    "invalidFormat": "Ugyldigt format",
    "invalid": "Ugyldig værdi"
  },
  "nav": {
    "workspace": "Arbejdsområde",
    "controlCenter": "Kontrolcenter",
    "jobs": "Stillinger",
    "analytics": "Analyse",
    "company": "Virksomhed",
    "agentCommunications": "Agentkommunikation",
    "integrations": "Integrationer",
    "suggestedCandidates": "Foreslåede kandidater",
    "unsolicitedApplications": "Uopfordrede ansøgninger",
    "team": "Team",
    "templates": "Skabeloner",
    "workflow": "Arbejdsgang",
    "settings": "Indstillinger",
    "language": "Sprog",
    "help": "Hjælp",
    "logout": "Log ud",
    "administration": "Administration",
    "adminTenant": "Lejerindstillinger",
    "adminOrganizations": "Organisationer",
    "adminDepartments": "Afdelinger",
    "adminFeedback": "Feedback",
    "openMenu": "Åben menu",
    "mcp": "MCP",
    "orgSettings": "Organisationsindstillinger"
  },
  "admin": {
    "tenants": {
      "title": "Lejere",
      "newTenant": "Ny lejer",
      "columns": {
        "name": "Navn",
        "createdAt": "Oprettet",
        "actions": "Handlinger"
      },
      "createDialog": {
        "title": "Opret lejer",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Rediger lejer"
      }
    },
    "tenant": {
      "title": "Lejerindstillinger",
      "name": "Lejernavn",
      "save": "Gem ændringer",
      "saved": "Gemt"
    },
    "organizations": {
      "title": "Organisationer",
      "newOrg": "Ny organisation",
      "columns": {
        "name": "Navn",
        "slug": "Slug",
        "tenant": "Lejer",
        "createdAt": "Oprettet",
        "actions": "Handlinger",
        "viewWorkspace": "Vis arbejdsområde"
      },
      "createDialog": {
        "title": "Opret organisation",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Ny lejer",
        "existingTenant": "Eksisterende lejer",
        "tenantName": "Lejernavn",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Vælg lejer"
      },
      "editDialog": {
        "title": "Rediger organisation",
        "language": "Sprog",
        "languagePlaceholder": "Vælg sprog"
      },
      "deleteConfirm": {
        "title": "Slet organisation",
        "description": "Dette vil også slette alle afdelinger i denne organisation. Denne handling kan ikke fortrydes.",
        "confirm": "Slet",
        "cancel": "Annuller"
      }
    },
    "departments": {
      "title": "Afdelinger",
      "newDept": "Ny afdeling",
      "columns": {
        "name": "Navn",
        "slug": "Slug",
        "createdAt": "Oprettet",
        "actions": "Handlinger"
      },
      "createDialog": {
        "title": "Opret afdeling",
        "namePlaceholder": "Engineering",
        "slugPlaceholder": "engineering"
      },
      "editDialog": {
        "title": "Rediger afdeling"
      },
      "deleteConfirm": {
        "title": "Slet afdeling",
        "description": "Denne handling kan ikke fortrydes.",
        "confirm": "Slet",
        "cancel": "Annuller"
      }
    },
    "viewingOrg": {
      "banner": "Viser: {{name}}",
      "leave": "Forlad"
    },
    "feedback": {
      "title": "Feedback",
      "columns": {
        "rating": "Vurdering",
        "modality": "Type",
        "candidate": "Kandidat",
        "job": "Stilling",
        "org": "Organisation",
        "notes": "Noter",
        "date": "Dato"
      },
      "modality": {
        "voice": "Stemme",
        "text": "Chat"
      },
      "thumbs": {
        "up": "Positiv",
        "down": "Negativ"
      },
      "filter": {
        "all": "Alle",
        "up": "Positiv",
        "down": "Negativ",
        "hasNotes": "Har noter"
      },
      "stats": {
        "title": "Negativ rate",
        "period": "Sidste 7 dage",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Ingen ændring",
        "wowNoPrev": "Ingen tidl. data",
        "noData": "Ingen data"
      },
      "noFeedback": "Ingen feedback endnu",
      "noNotes": "Ingen skriftlig kommentar"
    }
  },
  "team": {
    "title": "Team",
    "invite": "Inviter kolleger",
    "search": "Søg efter navn, e-mail, afdeling...",
    "department": "Afdeling",
    "roles": {
      "admin": "Admin",
      "org_manager": "Org. leder",
      "dept_manager": "Afdelingsleder",
      "user": "Bruger"
    },
    "columns": {
      "name": "Navn",
      "email": "E-mail",
      "role": "Rolle",
      "actions": "Handlinger"
    },
    "inviteDialog": {
      "title": "Inviter kollega",
      "name": "Navn",
      "namePlaceholder": "John Doe",
      "email": "E-mailadresse",
      "emailPlaceholder": "kollega@virksomhed.dk",
      "role": "Rolle",
      "departments": "Afdelinger",
      "submit": "Send invitation"
    },
    "actions": {
      "changeRole": "Skift rolle",
      "addDepartment": "Tilføj til afdeling",
      "removeDepartment": "Fjern fra afdeling",
      "removeFromOrg": "Fjern fra organisation"
    },
    "noResults": "Ingen resultater fundet.",
    "noMembers": "Ingen teammedlemmer endnu."
  },
  "jobs": {
    "title": "Stillinger",
    "backToJobs": "Stillinger",
    "newJob": "Ny stilling",
    "createNewJob": "Opret ny stilling",
    "importFromAts": "Importer fra {{atsName}}",
    "searchPlaceholder": "Søg i stillinger...",
    "completedPlaceholder": "{{completed}} af {{total}} færdiggjort",
    "tabs": {
      "active": "Aktive",
      "archived": "Arkiverede"
    },
    "columns": {
      "name": "Navn",
      "createdBy": "Oprettet af",
      "createdAt": "Oprettet",
      "actions": "Handlinger"
    },
    "empty": "Ingen stillinger fundet.",
    "emptyTitle": "Ingen stillinger endnu",
    "emptyDescription": "Opret din første stilling eller importer fra dit ATS for at komme i gang.",
    "emptyArchivedTitle": "Ingen arkiverede stillinger",
    "emptyArchivedDescription": "Arkiverede stillinger vises her.",
    "emptySearchDescription": "Ingen stillinger matcher din søgning.",
    "actions": {
      "archive": "Arkiver",
      "archiveConfirmTitle": "Arkiver stilling",
      "archiveConfirmDescription": "Er du sikker på, at du vil arkivere denne stilling? Den flyttes til fanen Arkiverede.",
      "archiveSuccess": "Stilling arkiveret",
      "archiveError": "Kunne ikke arkivere stilling. Prøv igen."
    },
    "createError": "Kunne ikke oprette stilling. Prøv igen.",
    "status": {
      "active": "Aktiv",
      "archived": "Arkiveret"
    },
    "setupStatus": {
      "draft": "Kladde",
      "questions_pending": "Opsætning påkrævet",
      "ready": "Klar",
      "active": "Aktiv"
    },
    "applicantSync": {
      "syncingBanner": "Henter kandidater fra {{provider}}...",
      "failedBanner": "Kandidatsynkronisering mislykkedes",
      "adminActions": "Adminhandlinger",
      "resyncLabel": "Synkroniser ansøgere nu",
      "lastSyncedAt": "Sidst synkroniseret: {{date}}",
      "addDemoApplicant": "Tilføj demoansøger"
    },
    "detail": {
      "tabs": {
        "candidates": "Kandidater",
        "results": "Resultater",
        "settings": "Indstillinger"
      },
      "info": {
        "title": "Stillingsinformation",
        "employer": "Arbejdsgiver",
        "location": "Lokation",
        "description": "Beskrivelse",
        "modality": "Interviewformat",
        "languages": "Sprog",
        "atsProvider": "ATS-udbyder",
        "atsId": "ATS-stillings-ID",
        "noDescription": "Ingen beskrivelse angivet."
      },
      "questions": {
        "title": "Interviewspørgsmål",
        "empty": "Ingen spørgsmål konfigureret for denne stilling.",
        "optional": "Valgfrit",
        "categories": {
          "eligibility": "Kvalifikationskrav",
          "nice_to_have": "Ønskeligt",
          "job_preview": "Jobforventninger",
          "assessment": "Vurdering",
          "information": "Information"
        }
      }
    }
  },
  "wizard": {
    "step": "Trin {{current}} af {{total}}",
    "back": "Tilbage",
    "next": "Fortsæt",
    "goLive": "Gå live",
    "saveAndContinue": "Gem & fortsæt",
    "manual": {
      "title": "Ny stilling",
      "step1Title": "Grundlæggende info",
      "step2Title": "Interviewspørgsmål",
      "step3Title": "Bekræft & gå live"
    },
    "import": {
      "title": "Importer fra ATS",
      "step0Title": "Vælg stillinger",
      "step1Title": "Tilknyt faser",
      "step2Title": "Interviewindstillinger",
      "step3Title": "Interviewspørgsmål",
      "step4Title": "Bekræft & gå live"
    },
    "stageSelector": {
      "title": "Tilknyt pipelinefaser",
      "description": "Vælg hvilken fase i hver stilling der svarer til hver Kiku-handling. Forudfyldt hvor fasenavne matchede dine standarder.",
      "continue": "Fortsæt",
      "loading": "Indlæser faser…"
    },
    "basicInfo": {
      "title": "Stillingsnavn",
      "titlePlaceholder": "f.eks. Senior Softwareudvikler",
      "description": "Stillingsbeskrivelse",
      "descriptionPlaceholder": "Beskriv rollen, ansvar og krav...",
      "descriptionHint": "Bruges af AI til at generere relevante interviewspørgsmål",
      "employer": "Arbejdsgivernavn (valgfrit)",
      "employerPlaceholder": "f.eks. Acme Corp",
      "modality": "Interviewformat",
      "modalityText": "Tekstchat",
      "modalityTextDesc": "Kandidaten skriver svar i en chatgrænseflade",
      "modalityVoice": "Stemmeinterview",
      "modalityVoiceDesc": "Live lydinterview afholdt i et virtuelt moedelokale",
      "languages": "Interviewsprog",
      "languagesHint": "Vælg mindst et sprog",
      "languagesSearch": "Søg sprog…",
      "languagesEmpty": "Intet sprog fundet.",
      "modalityRequired": "Vælg mindst et interviewformat",
      "languagesRequired": "Vælg mindst et sprog"
    },
    "atsSelector": {
      "title": "Vælg stillinger til import",
      "search": "Søg stillinger...",
      "selectAll": "Vælg alle",
      "selected": "{{count}} valgt",
      "noJobs": "Ingen aktive stillinger fundet i dit ATS",
      "noDescription": "Ingen beskrivelse tilgængelig — AI genererer ud fra titel alene",
      "continue": "Fortsæt med {{count}} stilling(er)"
    },
    "sharedSettings": {
      "title": "Interviewindstillinger",
      "subtitle": "Disse indstillinger gælder for alle importerede stillinger",
      "employer": "Arbejdsgivernavn",
      "employerPlaceholder": "f.eks. Acme Corp"
    },
    "questions": {
      "title": "Interviewspørgsmål",
      "generateError": "Kunne ikke generere spørgsmål. Prøv igen.",
      "retry": "Prøv igen",
      "generating": "Forbereder spørgsmål for at finde de bedste kandidater…",
      "generatingHint": "Det tager normalt få sekunder",
      "addQuestion": "Tilføj spørgsmål",
      "categories": {
        "eligibility": "Kvalifikationskrav",
        "nice_to_have": "Ønskeligt",
        "job_preview": "Realistisk jobbeskrivelse",
        "assessment": "Vurdering",
        "information": "Informationsindsamling"
      },
      "categoryDescriptions": {
        "eligibility": "Ja/nej-spørgsmål om ufravigelige krav",
        "nice_to_have": "Ja/nej-spørgsmål om ønskelige men ikke påkrævede kvalifikationer",
        "job_preview": "Fremhaever en udfordrende del af rollen. Hjælper med at sikre, at kandidaten forstaar, hvad rollen indebærer, og forebygger frafald",
        "assessment": "Adfærds- og kompetencespørgsmål",
        "information": "Spoergsmaal til at indsamle kontekst — bruges ikke i scoring"
      },
      "categoryPurpose": {
        "eligibility": "Bestå eller dumpet",
        "job_preview": "Bestå eller dumpet",

        "assessment": "Bedømmes",
        "information": "Kun til information"
      },
      "optional": "Valgfrit",
      "competency": "Kompetence",
      "scoringExamples": "Scoringsankre",
      "editScoringExamples": "Rediger scoringsankre",
      "regenerateScoringExamples": "Regenerer scoringsankre",
      "dontRegenerateScoringExamples": "Regenerer ikke scoringsankre",
      "regeneratingScoringExamples": "Regenererer...",
      "regenerateScoringError": "Kunne ikke regenerere scoringsankre",
      "score1": "Score 1 — Dårlig",
      "score3": "Score 3 — Tilstrækkelig",
      "score5": "Score 5 — Fremragende",
      "aiGenerated": "AI-genereret"
    },
    "confirm": {
      "title": "Klar til at gå live",
      "jobsCount": "{{count}} stilling(er) vil blive aktiveret",
      "questionsCount": "{{count}} interviewspørgsmål",
      "modality": "Format",
      "languages": "Sprog",
      "goLiveHint": "Kandidater kan starte interviews umiddelbart efter aktivering."
    }
  },
  "login": {
    "title": "Log ind på Kiku",
    "subtitle": "Administrer din rekrutteringspipeline.",
    "cta": "Log ind",
    "waitingForLogin": "Venter på login…",
    "disclosure": "Du interagerer med et AI-system. Kiku bruger AI til at assistere med rekruttering — alle beslutninger er underlagt menneskelig gennemgang.",
    "errors": {
      "not_provisioned": "Din konto er ikke opsat endnu. Kontakt din administrator.",
      "missing_code": "Autentificering mislykkedes. Prøv igen.",
      "session_expired": "Din session er udløbet. Log ind igen."
    }
  },
  "settings": {
    "profile": {
      "title": "Profil",
      "name": "Navn",
      "email": "E-mail",
      "role": "Rolle",
      "departments": "Afdelinger"
    }
  },
  "integrations": {
    "title": "Integrationer",
    "ats": {
      "title": "ATS-forbindelse",
      "description": "Forbind dit Applicant Tracking System for at synkronisere stillinger og håndtere kandidatfaser.",
      "provider": "Udbyder",
      "apiKey": "API-nøgle",
      "apiKeyPlaceholder": "Indtast din API-nøgle",
      "apiKeySet": "Nøgle gemt — indtast en ny værdi for at erstatte den",
      "save": "Gem forbindelse",
      "verify": "Verificer forbindelse",
      "verifyStatus": {
        "valid": "Forbundet",
        "invalid": "Ugyldig nøgle",
        "error": "Verificering mislykkedes",
        "idle": "Ikke verificeret",
        "loading": "Verificerer..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor er en rekrutteringsplatform, der hjælper virksomheder med at tiltrække, pleje og ansætte de bedste kandidater.",
        "recmanDescription": "RecMan er et rekrutteringssystem til bemandingsbureauer og rekrutteringsbureauer på det nordiske marked.",
        "logicmelonDescription": "LogicMelon er et multi-posting ATS til højvolumen-rekruttering, populært i den britiske uddannelsessektor."
      }
    },
    "stageMapping": {
      "title": "Fasetilknytning",
      "description": "Tilknyt dine ATS-faser til Kiku-arbejdsgangsfaser.",
      "initialStage": "Startfase",
      "passInterviewStage": "Bestået interview",
      "failInterviewStage": "Ikke bestået interview",
      "recommendedStage": "Anbefalet",
      "selectStage": "Vælg en fase",
      "save": "Gem tilknytning"
    },
    "errors": {
      "notConfigured": "Intet ATS konfigureret. Gem din forbindelse først.",
      "fetchStagesFailed": "Kunne ikke indlæse faser fra dit ATS.",
      "saveFailed": "Kunne ikke gemme konfigurationen."
    }
  },
  "applications": {
    "title": "Ansøgninger",
    "newCandidate": "Ny kandidat",
    "addCandidate": "Tilføj ny kandidat",
    "importFromCsv": "Importer fra CSV",
    "importDialog": {
      "title": "Importer kandidater",
      "back": "Tilbage",
      "next": "Næste",
      "upload": {
        "hint": "Træk og slip en CSV-fil her, eller klik for at gennemse",
        "csvOnly": "Kun CSV-filer",
        "browse": "Gennemse"
      },
      "mapping": {
        "headerRow": "Første række er overskrift",
        "nameColumn": "Navnekolonne",
        "emailColumn": "E-mailkolonne",
        "phoneColumn": "Telefonkolonne",
        "notMapped": "— ikke tilknyttet —",
        "column": "Kolonne",
        "preview": "Forhåndsvisning"
      },
      "review": {
        "allValid": "Alle {{count}} kandidater er gyldige",
        "summary": "{{valid}} gyldige · {{invalid}} ugyldige",
        "skipInvalid": "Spring ugyldige rækker over og importer {{count}} gyldige kandidater",
        "recheck": "Tjek igen",
        "import": "Importer {{count}} kandidater",
        "colName": "Navn",
        "colEmail": "E-mail",
        "colPhone": "Telefon",
        "colStatus": "Status"
      },
      "errors": {
        "nameRequired": "Påkrævet",
        "emailInvalid": "Ugyldig e-mail",
        "emailDuplicate": "Duplikeret e-mail i denne fil",
        "phoneInvalid": "Kræver landekode (f.eks. +45…)"
      },
      "success": {
        "title": "Import færdig",
        "body": "{{created}} importeret, {{conflict}} havde allerede ansøgninger (sprunget over), {{error}} mislykkedes.",
        "done": "Faerdig"
      }
    },
    "screening": "Screening",
    "aiRanked": "AI-rangeret",
    "emptyStage": "Ingen ansøgninger",
    "emptyTitle": "Ingen kandidater endnu",
    "emptyDescription": "Tilføj din første kandidat for at begynde at gennemgå ansøgninger.",
    "emptySearchDescription": "Ingen kandidater matcher din søgning.",
    "searchPlaceholder": "Søg efter navn, e-mail eller telefon",
    "createDialog": {
      "title": "Tilføj ansøgning",
      "name": "Fulde navn",
      "namePlaceholder": "f.eks. Jane Doe",
      "email": "E-mailadresse",
      "emailPlaceholder": "f.eks. jane@example.com",
      "phoneNumber": "Telefonnummer",
      "phoneNumberPlaceholder": "f.eks. 555-1234",
      "phoneCountryCode": "Landekode",
      "phoneCountryCodePlaceholder": "f.eks. +45",
      "submit": "Opret ansøgning"
    },
    "errors": {
      "conflict": "Denne kandidat har allerede en ansøgning til denne stilling."
    },
    "detail": {
      "title": "Ansøgningsdetaljer",
      "tabs": {
        "application": "Ansøgning",
        "profile": "Profil",
        "activity": "Aktivitet"
      },
      "stage": "Fase",
      "interviewLink": "Interviewlink",
      "interviewStatus": "Interviewstatus",
      "copyLink": "Kopier link",
      "linkCopied": "Kopieret!",
      "noInterview": "Ingen interviewsession fundet",
      "noResults": {
        "title": "Interview ikke færdiggjort",
        "description": "Denne kandidat har endnu ikke taget interviewet. Del interviewlinket for at komme i gang."
      },
      "inProgress": {
        "title": "Interview i gang",
        "description": "Denne kandidat har startet interviewet. Resultaterne vises her, når det er afsluttet."
      },
      "openInterview": "Åben interview",
      "commChannel": {
        "label": "Send via",
        "manual": "Manuelt",
        "email": "E-mail",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "Afventer",
        "in_progress": "I gang",
        "completed": "Faerdiggjort",
        "expired": "Udloebet"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Rækker pr. side",
    "rowsSelected": "{{count}} af {{total}} række(r) valgt.",
    "pageOf": "Side {{page}} af {{total}}",
    "previous": "Forrige",
    "next": "Næste"
  },
  "screening": {
    "title": "Screeninginterview",
    "aiDisclosure": "Du chatter med Sara, en AI-rekrutteringsassistent",
    "selectLanguage": "Vælg dit foretrukne sprog",
    "selectLanguageDescription": "Interviewet gennemføres på det sprog, du vælger",
    "startInterview": "Start interview",
    "previewJobTitle": "Eksempelstilling — Eksempelvirksomhed",
    "typeMessage": "Skriv din besked...",
    "send": "Send",
    "typing": "Sara skriver...",
    "submitInterview": "Indsend interview",
    "loading": "Indlæser interview...",
    "completed": {
      "title": "Interview færdiggjort",
      "submitted": "Interview indsendt",
      "message": "Tak fordi du gennemførte interviewet til {{jobTitle}}. En rekrutterer vil gennemgå dine svar og vende tilbage."
    },
    "expired": {
      "title": "Interview udløbet",
      "message": "Dette interviewlink er udløbet. Kontakt venligst rekruttereren for en ny invitation."
    },
    "notFound": {
      "title": "Interview ikke fundet",
      "message": "Dette interviewlink er ugyldigt. Tjek venligst linket og prøv igen."
    },
    "feedback": {
      "helpUsImprove": "Hjælp os med at forbedre",
      "teaser": "Hvordan var interviewoplevelsen?",
      "overallPrompt": "Hvordan var den samlede interviewoplevelse?",
      "disclaimer": "Vi vil meget gerne have din feedback — den er anonym og påvirker ikke din ansøgning.",
      "prompt": "Hvordan gik interviewet?",
      "good": "Godt",
      "bad": "Dårligt",
      "notesLabel": "Yderligere kommentarer?",
      "notesPlaceholder": "Fortael os mere (valgfrit)...",
      "skip": "Spring over",
      "submit": "Indsend feedback",
      "submitError": "Kunne ikke indsende feedback. Prøv igen."
    },
    "technicalIssue": {
      "buttonLabel": "Teknisk problem?",
      "modalTitle": "Rapporter et teknisk problem",
      "modalDescription": "Beskriv det problem, du oplevede. Din feedback sendes, og interviewet genstartes.",
      "notesLabel": "Hvad gik galt?",
      "notesPlaceholder": "F.eks. Siden froes, og jeg mistede min fremgang...",
      "submitButton": "Send feedback og genstart",
      "submitError": "Kunne ikke indsende. Prøv igen.",
      "cancel": "Annuller"
    },
    "error": {
      "title": "Noget gik galt",
      "message": "Der opstod en fejl. Prøv igen senere.",
      "sendFailed": "Kunne ikke sende besked. Prøv igen."
    },
    "languages": {
      "en": "Engelsk",
      "da": "Dansk",
      "sv": "Svensk",
      "de": "Tysk",
      "fr": "Fransk",
      "es": "Spansk",
      "nl": "Hollandsk",
      "pl": "Polsk",
      "fi": "Finsk",
      "ro": "Rumænsk"
    },
    "landing": {
      "badge": "JOBINTERVIEW",
      "greeting": "Hej {{name}}! Vi er glade for, at du er her. Dette er en invitation til et hurtigt online screeninginterview med en AI for at lære dig at kende. Tag det, naar du er klar.",
      "startChat": "Start chatinterview",
      "startVoice": "Start stemmeinterview",
      "or": "eller",
      "minutes": "{{count}} minutter",
      "questions": "{{count}} spørgsmål"
    },
    "modality": {
      "title": "Vælg interviewformat",
      "description": "Vælg, hvordan du vil gennemføre interviewet",
      "text": "Tekstinterview",
      "textDescription": "Skriv dine svar i en chat",
      "voice": "Stemmeinterview",
      "voiceDescription": "Sig dine svar højt"
    },
    "deviceTest": {
      "title": "Tjek din lyd",
      "description": "Sørg for, at din mikrofon og højttalere virker, foer du starter",
      "microphone": "Mikrofon",
      "speakers": "Hoejttalere",
      "testMicrophone": "Tillad mikrofonadgang",
      "testSpeakers": "Afspil testlyd",
      "playAgain": "Afspil igen",
      "requestingPermission": "Anmoder om tilladelse...",
      "microphoneDenied": "Mikrofonadgang blev nægtet. Tillad adgang i dine browserindstillinger.",
      "confirm": "Alt virker — start interview"
    },
    "voice": {
      "title": "Stemmeinterview",
      "connecting": "Forbinder...",
      "recording": "Optager",
      "interviewInProgress": "Interview i gang",
      "inProgress": "Interview i gang — tal naturligt",
      "muted": "Din mikrofon er slået fra",
      "finished": "Interview færdigt — tak!",
      "alreadyInProgress": "Interview i gang",
      "alreadyInProgressMessage": "Dit stemmeinterview er i øjeblikket aktivt. Genstart vil annullere den nuværende session — gør det kun, hvis du ikke længere er forbundet.",
      "retryButton": "Genstart interview"
    }
  },
  "scoring": {
    "title": "Interviewresultater",
    "pending": "Scoring i gang...",
    "processing": "AI evaluerer interviewet...",
    "failed": "Scoring mislykkedes",
    "overallScore": "Samlet score",
    "overallScoreTooltip": "Score fra 0–100 baseret på gennemsnittet af alle vurderingsspørgsmål, justeret for kvalifikationskrav og jobforventninger.",
    "outcome": "Resultat",
    "outcomes": {
      "pass": "Bestået",
      "fail": "Ikke bestået"
    },
    "summary": "Resumé",
    "eligibility": "Kvalifikationskrav",
    "niceToHave": "Ønskeligt",
    "expectations": "Jobforventninger",
    "assessment": "Vurdering",
    "information": "Informationsindsamling",
    "scoringAnchors": "Scoringsankre",
    "candidateAnswer": "Kandidatens svar",
    "transcript": "Interviewtransskription",
    "viewInTranscript": "Vis i transskription",
    "copyPasteDetected": "Kopieret svar",
    "copyPasteWarning": "Kopier-indsæt registreret i dette interview",
    "copyPasteWarningTooltip": "Et eller flere kandidatsvar blev indsat under interviewet. Dette kan indikere, at kandidaten brugte forudskrevne svar.",
    "verdicts": {
      "pass": "Bestået",
      "fail": "Ikke bestået",
      "unsure": "Usikker",
      "review": "Kræver gennemgang"
    },
    "optional": "Valgfrit",
    "averageScore": "Gennemsnitlig spørgsmålsscore",
    "reasoning": "Begrundelse",
    "evidence": "Dokumentation",
    "backToJob": "Tilbage til stilling",
    "overrideDialog": {
      "title": "Tilsidesæt score",
      "titleVerdict": "Tilsidesæt vurdering",
      "currentValue": "Nuværende værdi",
      "newValue": "Ny værdi",
      "reason": "Årsag til tilsidesættelse",
      "reasonPlaceholder": "Forklar, hvorfor du ændrer denne score...",
      "reasonMinLength": "Minimum {{min}} tegn påkrævet",
      "save": "Gem tilsidesættelse",
      "cancel": "Annuller",
      "error": "Kunne ikke gemme tilsidesættelse. Prøv igen."
    }
  },
  "workflows": {
    "title": "Arbejdsgang",
    "description": "Konfigurer de faser, som ansøgninger gennemgaar i din ansættelsesproces.",
    "stages": {
      "title": "Pipelinefaser",
      "subtitle": "Træk for at omsortere. Ansøgninger gennemgaar disse faser fra top til bund.",
      "system": "System",
      "manage": "Håndter faser",
      "addStage": "Tilføj fase",
      "editStage": "Rediger fase",
      "deleteStage": "Slet fase",
      "stageName": "Fasenavn",
      "stageNamePlaceholder": "f.eks. Telefonscreening",
      "stageColor": "Farve",
      "deleteConfirm": "Slet denne fase? Ansøgninger i denne fase skal flyttes først.",
      "systemProtected": "Systemfaser kan ikke slettes",
      "hasApplications": "Denne fase har stadig ansøgninger tilknyttet"
    }
  },
  "communications": {
    "title": "Agentkommunikation",
    "languageSelector": "Sprog",
    "tabs": {
      "sms": "SMS",
      "email": "E-mail"
    },
    "emailSubject": "Emne",
    "emailBody": "Indhold",
    "variables": {
      "applicantName": "Ansøgerens navn",
      "jobTitle": "Stillingsnavn",
      "jobEmployer": "Arbejdsgiver",
      "jobLocation": "Jobplacering",
      "jobDescription": "Stillingsbeskrivelse",
      "recruiterName": "Rekruttererens navn",
      "inviteUrl": "Invitationslink"
    },
    "actions": {
      "edit": "Rediger",
      "save": "Gem ændringer",
      "reset": "Nulstil til standard",
      "saved": "Skabelon gemt",
      "resetDone": "Nulstillet til standard"
    },
    "nodes": {
      "interviewIntro": "Interviewintro",
      "interviewOutro": "Interviewoutro",
      "reminderToFinish": "Påmindelse om at færdiggøre",
      "voiceAndChat": "Stemme & Chat",
      "emailsAndSms": "E-mails & SMS",
      "comingSoon": "Kommer snart"
    },
    "characters": "{{count}}/{{max}} Tegn",
    "smsSegments": "{{count}} SMS-beskeder ({{size}} tegn/segment)",
    "smsUnicodeWarning": "Denne besked indeholder emojis eller specialtegn, der kræver Unicode-kodning, hvilket reducerer graensen til 67 tegn pr. SMS.",
    "invite": {
      "title": "Kandidatinvitation",
      "description": "Kandidater modtager denne besked, naar de tilfojes til en stilling. E-mailen inkluderer automatisk et link til interviewet.",
      "email": {
        "subject": "Du er inviteret til dit {{jobTitle}}-interview! 🎯",
        "body": "<p>Hej {{applicantName}},</p><p>Du er blevet inviteret til at gennemføre et hurtigt online screeninginterview med vores AI-interviewer til stillingen <strong>{{jobTitle}}</strong> hos <strong>{{jobEmployer}}</strong>.</p><p>Det er en enkel måde for os at lære dig bedre at kende — tag det, når det passer dig, uanset hvor du er. Det tager kun få minutter!</p><p><a href=\"{{inviteUrl}}\">Start interview</a></p><p>Held og lykke!<br>{{jobEmployer}}</p>"
      },
      "sms": "Hej {{applicantName}}, jeg er Sara, {{jobEmployer}}s AI-jobassistent. Du er inviteret til interview for {{jobTitle}}. Det tager kun få minutter: {{inviteUrl}} (Ingen svar)"
    },
    "reminder": {
      "title": "Interviewpåmindelse",
      "description": "Sendes automatisk, hvis en kandidat ikke har startet sit interview inden for 24 timer efter modtagelse af invitationen.",
      "email": {
        "subject": "Glem ikke dit {{jobTitle}}-interview",
        "body": "<p>Hej {{applicantName}},</p><p>Vi har bemærket, at du endnu ikke har gennemført dit AI-screeninginterview til stillingen <strong>{{jobTitle}}</strong> hos <strong>{{jobEmployer}}</strong>.</p><p>Dette er din chance for at komme et skridt nærmere — det tager kun få minutter, og gennemførelse vil øge dine chancer for at gå videre til næste fase.</p><p><a href=\"{{inviteUrl}}\">Gennemfør interview nu</a></p><p>Med venlig hilsen,<br>{{jobEmployer}}</p>"
      },
      "sms": "Hej {{applicantName}}, bare en venlig påmindelse — du har endnu ikke gennemført dit {{jobTitle}}-interview hos {{jobEmployer}}. Det tager kun få minutter og hjælper dine chancer: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Skriv din e-mail...",
    "preview": {
      "outroSampleIntro": "Det var det hele — tak for dine svar!",
      "outroSampleAnswer": "Ingen problem, glad for at hjælpe."
    },
    "intro": {
      "title": "Interviewintro",
      "description": "Den præcise åbningsbesked Sara siger for at hilse på kandidaten og spørge, om de er klar til at begynde.",
      "scriptLabel": "Introbesked",
      "scriptPlaceholder": "Skriv den præcise åbningsbesked Sara skal sige...",
      "defaultScript": "Hej! Jeg er Sara, en AI-rekrutteringsassistent for {{jobEmployer}}. Tak fordi du tager dig tid til at interviewe til stillingen {{jobTitle}} — det tager kun et par minutter. Er du klar til at begynde? 😊"
    },
    "outro": {
      "title": "Interviewoutro",
      "description": "Den præcise afsluttende besked Sara siger, naar alle spørgsmål er besvaret.",
      "scriptLabel": "Outrobesked",
      "scriptPlaceholder": "Skriv den præcise afsluttende besked Sara skal sige...",
      "defaultScript": "Det var det hele — tusind tak for din tid i dag! En rekrutterer vil gennemgå dine svar og vende tilbage. Held og lykke! 🙂"
    }
  },
  "activity": {
    "title": "Aktivitet",
    "stageChange": "Flyttet fra {{from}} til {{to}}",
    "interviewCompleted": "Faerdiggjorde screeninginterview",
    "scoreReceived": "Score modtaget: {{score}}/100",
    "applicationCreated": "Ansøgning oprettet",
    "noteAdded": "Note tilføjet",
    "bySystem": "System",
    "byAi": "AI",
    "empty": "Ingen aktivitet endnu",
    "emptyTitle": "Ingen aktivitet endnu",
    "emptyDescription": "Handlinger og hændelser for denne kandidat vises her."
  },
  "atsPush": {
    "title": "ATS-sendestatus",
    "retry": "Prøv ATS-afsendelse igen",
    "retrying": "Prøver igen...",
    "rerunStep": "Kør dette trin igen",
    "rerunConfirm": "Dette trin er allerede gennemført. At køre det igen kan oprette duplikatdata i dit ATS. Fortsæt?",
    "steps": {
      "transcript": "Transskription",
      "stage_move": "Faseflytning"
    },
    "status": {
      "completed": "Sendt",
      "failed": "Mislykkedes",
      "pending": "Afventer"
    },
    "note": {
      "title": "AI-screeninginterview",
      "outcome": "Resultat",
      "score": "Score",
      "summary": "Resumé",
      "eligibility": "Kvalifikationskrav",
      "assessment": "Vurdering",
      "transcript": "Transskription",
      "candidate": "Kandidat",
      "interviewer": "Interviewer",
      "pass": "Bestået",
      "fail": "Ikke bestået",
      "review": "Gennemgang",
      "shortlist": "Shortlist",
      "reject": "Afvis",
      "viewProfile": "Se kandidatprofil i Kiku",
      "transcriptAndAssessment": "TRANSSKRIPTION OG VURDERING",
      "intro": "Intro",
      "eligibilityQuestions": "Kvalifikationsspørgsmål",
      "jobExpectations": "Jobforventninger",
      "assessmentQuestions": "Vurderingsspørgsmål",
      "outro": "Outro",
      "assessmentExplanation": "VURDERINGSFORKLARING",
      "unsure": "Usikker",
      "viewInKiku": "SE I KIKU FOR FLERE DETALJER",
      "viewProfileLink": "Se kandidatprofil i Kiku for at se forklaringer på scores"
    }
  },
  "topbar": {
    "whatsNew": "Nyheder",
    "help": "Hjælp",
    "notifications": "Notifikationer"
  },
  "extension_candidate_banner": {
    "description": "Se kandidatdetaljer.",
    "description_with_transcript": "Se screeningtransskription og kandidatdetaljer.",
    "open_in_kiku": "Åben",
    "dismiss": "Afvis"
  },
  "languages": {
    "en": "Engelsk",
    "da": "Dansk",
    "sv": "Svensk",
    "de": "Tysk",
    "fr": "Fransk",
    "es": "Spansk",
    "nl": "Hollandsk",
    "pl": "Polsk",
    "fi": "Finsk",
    "ro": "Rumænsk"
  },
  "environmentBanner": {
    "development": "Udvikling",
    "test": "Test"
  },
  "notFound": {
    "title": "Side ikke fundet",
    "description": "Siden du leder efter, findes ikke eller er blevet flyttet.",
    "goHome": "Tilbage til Kiku"
  },
  "candidateProfile": {
    "title": "Kandidater",
    "cv": {
      "title": "CV / Resume",
      "upload": "Upload CV",
      "replace": "Erstat CV",
      "uploadDescription": "Upload et CV for at udtrække strukturerede profildata",
      "uploadLimit": "Maks. 10 MB — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Se originalt CV",
      "status": {
        "pending": "I koe",
        "processing": "Behandler...",
        "done": "Behandlet",
        "failed": "Behandling mislykkedes"
      },
      "parsed": {
        "title": "Udtrukket profil",
        "skills": "Faerdigheder",
        "experience": "Erfaring",
        "education": "Uddannelse",
        "languages": "Sprog",
        "certifications": "Certificeringer",
        "present": "Nu"
      },
      "errors": {
        "unsupportedType": "Ikke-understøttet filtype. Upload venligst en PDF, DOCX, PNG, JPG eller WEBP.",
        "tooLarge": "Filen er for stor. Maksimal stoerrelse er 10 MB.",
        "uploadFailed": "Kunne ikke uploade CV. Prøv igen."
      }
    }
  },
  "results": {
    "exportLabel": "Eksporter",
    "exportCsv": "Eksporter CSV",
    "csv": {
      "headers": {
        "candidateName": "Kandidatnavn",
        "email": "E-mail",
        "role": "Rolle",
        "stage": "Fase",
        "overallScore": "Samlet score",
        "outcome": "Resultat",
        "eligibility": "Kvalifikationskrav",
        "expectations": "Forventninger",
        "avgScore": "Gns. score",
        "interviewDate": "Interviewdato",
        "status": "Status"
      }
    },
    "emptyTitle": "Ingen resultater endnu",
    "emptyDescription": "Faerdiggjorte interviews vises her.",
    "columns": {
      "candidate": "Kandidat",
      "stage": "Fase",
      "status": "Status",
      "score": "Score",
      "outcome": "Resultat",
      "eligibility": "Kvalifikationskrav",
      "expectations": "Forventninger",
      "avgScore": "Gns. score",
      "interviewDate": "Interviewdato",
      "question": "Spoergsmaal"
    },
    "statusLabels": {
      "pending": "Afventer",
      "processing": "Behandler",
      "completed": "Faerdiggjort",
      "failed": "Mislykkedes",
      "no_interview": "Intet interview"
    },
    "questionSections": {
      "eligibility": "Kvalifikationskrav",
      "job_preview": "Forventninger",
      "nice_to_have": "Ønskeligt",
      "assessment": "Vurdering",
      "information": "Information"
    },
    "fields": {
      "reasoning": "Begrundelse",
      "evidence": "Dokumentation",
      "response": "Svar",
      "avgScoreLabel": "Gns. score",
      "interviewDate": "Interviewdato"
    }
  },
  "orgSettings": {
    "title": "Organisationsindstillinger",
    "branding": {
      "title": "Branding",
      "logo": "Organisationslogo",
      "logoDescription": "Upload et logo for at erstatte standardlogoet fra Kiku i navigationslinjen.",
      "uploadLogo": "Upload logo",
      "removeLogo": "Fjern logo",
      "logoHint": "PNG, JPG, WebP eller SVG. Maks. 2 MB.",
      "uploadSuccess": "Logo opdateret",
      "removeSuccess": "Logo fjernet",
      "uploadError": "Kunne ikke uploade logo"
    },
    "timezone": {
      "title": "Tidszone",
      "description": "Indstil standardtidszonen for planlaegning og visning af datoer.",
      "label": "Tidszone",
      "saveSuccess": "Tidszone opdateret",
      "saveError": "Kunne ikke opdatere tidszone"
    },
    "save": "Gem ændringer"
  },
  "mcp": {
    "title": "MCP-integration",
    "subtitle": "Forbind AI-assistenter til Kiku via Model Context Protocol",
    "whatIsMcp": "Hvad er MCP?",
    "whatIsMcpDescription": "Model Context Protocol (MCP) lader AI-assistenter som Claude, ChatGPT og andre vaerktoejer interagere direkte med Kiku — liste stillinger, se kandidater og administrere din rekrutteringspipeline via naturligt sprog.",
    "serverUrl": "Server URL",
    "copyUrl": "Kopier URL",
    "copied": "Kopieret!",
    "availableTools": "Tilgaengelige vaerktoejer",
    "toolListJobs": "Søg og list jobopslag med afdelingsnavne, filtre for status, opsætningsstatus og afdeling.",
    "toolGetJob": "Hent alle detaljer om et specifikt jobopslag, inkl. afdelingsnavn.",
    "toolCreateJob": "Opret et nyt stillingsopslag i en afdeling.",
    "toolAdvanceSetup": "Fremryk en stilling gennem opsætningsfaser (kladde, spørgsmål_afventer, klar, aktiv).",
    "toolListApplications": "List ansøgninger for en stilling med fasenavne, scoringsstatus og resultat.",
    "toolGetInterviewResults": "Hent AI-interviewresultater for en ansøgning — score, resultat og spørgsmål-for-spørgsmål-nedbrydning med begrundelse.",
    "toolGetPipelineSummary": "Hent et pipeline-overblik for en stilling — kandidattal pr. fase med bestået/ikke-bestået totaler.",
    "setupTitle": "Opsætning med Claude Desktop",
    "setupStep1": "Åbn Claude Desktop",
    "setupStep2": "Klik på Customize i venstre sidebar",
    "setupStep3": "Klik på Connectors, derefter +-ikonet, derefter Add custom connector",
    "setupStep4": "Indtast Name: Kiku og Server URL'en vist ovenfor",
    "setupStep5": "Klik Add — Claude kan nu bruge dine Kiku-data"
  }
}
